export default "__VITE_ASSET__zXl0JZrx__ 778w";